import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { adminApi } from '@formosa/shared/api/admin';
import { ApiError } from '@formosa/shared/api/createClient';
import { useAuth } from '../../auth/AuthContext';
import {
  shouldShowLoginGoogleField,
  useGoogleVerifyConfig,
} from '../../hooks/useGoogleVerifyConfig';

export default function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { loginSuccess } = useAuth();
  const { config, loading: configLoading } = useGoogleVerifyConfig();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [googleCode, setGoogleCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const from = location.state?.from?.pathname || '/';
  const showGoogleField = shouldShowLoginGoogleField(config);

  useEffect(() => {
    if (!showGoogleField) {
      setGoogleCode('');
    }
  }, [showGoogleField]);

  async function handleSubmit(event) {
    event.preventDefault();
    setError('');
    setLoading(true);

    try {
      const payload = { username, password };
      const code = googleCode.trim();
      if (code) {
        payload.googleCode = code;
      }
      const data = await adminApi.login(payload);
      if (!data?.authToken) {
        setError('帳號或密碼錯誤');
        return;
      }
      loginSuccess(data);
      navigate(from, { replace: true });
    } catch (err) {
      const message =
        err instanceof ApiError ? err.message : '登入失敗，請稍後再試';
      setError(message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth-card">
      <h1>後台登入</h1>
      <p>管理員帳號登入 Formosa 後台</p>

      {error && <div className="alert alert-error">{error}</div>}

      <form onSubmit={handleSubmit}>
        <div className="form-field">
          <label htmlFor="username">帳號</label>
          <input
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="username"
            required
          />
        </div>

        <div className="form-field">
          <label htmlFor="password">密碼</label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
          />
        </div>

        {showGoogleField && (
          <div className="form-field">
            <label htmlFor="loginGoogleCode">谷歌驗證碼</label>
            <input
              id="loginGoogleCode"
              type="text"
              inputMode="numeric"
              value={googleCode}
              onChange={(e) => setGoogleCode(e.target.value)}
              placeholder="已綁定谷歌時必填"
              disabled={configLoading}
            />
            {config.allowBypassCode && (
              <p className="page-desc form-note">測試環境可使用萬用碼 123456</p>
            )}
          </div>
        )}

        <button
          type="submit"
          className="btn btn-primary btn-block"
          disabled={loading || configLoading}
        >
          {loading ? '登入中…' : '登入'}
        </button>
      </form>
    </div>
  );
}
